import React from 'react';

import SystemAttributesCard from './configurator-cards/SystemAttributesCard.jsx';
import BaselineConfigCard from './configurator-cards/BaselineConfigCard.jsx';

const BaseSystemView = ({
    config,
    updateConfig,
    batchUpdateConfig,
    loadConfig,
    metrics,
    baselineMetrics,
    affectedKeys,
    staleKeys,
    pricingData,
    vendor,
    consultationMode,
    hasSpecialAccess,
    hasExecAccess = false, // CONF-212: gates Custom Metrics
    hasDualCpuAccess = false, // CONF-210/259: unlocks the Flash Node Model control
    prices,
    execMetrics,
    showExecMetrics,
    onToggleExecMetrics,
}) => {
    // MORK TODO : Look at how we fill the UI with compression ratio from productDb. Is this the best place? Also the AFA/Hybrid compression ratio lists
    //             populate from the productDb compressionRatio array. 
    // const compressionRatio = productDb.compressionRatio;
    // // MORK TODO : Look at how we fill the UI with JBOD sizes and HDD capacities from productDb. Is this the best place?
    // const jbodSizes = productDb.jbodSizes;
    // const hddCapacities = productDb.hddCapacities;
    // const veloSsdCapacities = productDb.veloSsdCapacities;


    const { branding, capabilities, businessRules, databases } = vendor;
    const productDb = databases.products;


    return (
        <>
            <BaselineConfigCard
                config={config}
                updateConfig={updateConfig}
                batchUpdateConfig={batchUpdateConfig}
                productDb={productDb}
                hasSpecialAccess={hasSpecialAccess}
                hasDualCpuAccess={hasDualCpuAccess}
                theme={branding.theme}
                capabilities={capabilities}
                metrics={metrics}
            />
            <SystemAttributesCard
                config={config}
                updateConfig={updateConfig}
                batchUpdateConfig={batchUpdateConfig}
                productDb={productDb}
                metrics={metrics}
                baselineMetrics={baselineMetrics}
                affectedKeys={affectedKeys}
                staleKeys={staleKeys}
                pricingData={pricingData}
                hardwareVendor={vendor.id}
                theme={branding.theme}
                consultationMode={consultationMode}
                softwareSubscriptionOnly={businessRules.softwareSubscriptionOnly === true}
                hasSpecialAccess={hasSpecialAccess}
                hasExecAccess={hasExecAccess}
                execMetrics={execMetrics}
                showExecMetrics={showExecMetrics}
                onToggleExecMetrics={onToggleExecMetrics}
            />
        </>
    );




//   return (
//     <Card>
//       <CardHeader className={vendorStyles.cardHeader}>
//         <div className="flex justify-between items-center">
//           <CardTitle className={vendorStyles.cardTitle}>Baseline System Configuration</CardTitle>

//           <div className="flex items-center space-x-4">
//             {/* Hardware vendor toggle - only shown if user is in dellHardware group */}
//             {hasDellAccess && (
//               <div className="flex items-center h-8 absolute left-1/2 transform -translate-x-1/2">
//                 {/* AIC logo */}
//                 {/* these img tags assume aicLogo / dellLogo are still used in App.js header; 
//                     if you want them here too, pass logo URLs as props */}
//                 {/* You can also move the logo imports into this file if preferred */}
//               </div>
//             )}

//             {/* Consultation mode toggle - always visible */}
//             <div className="flex items-center">
//               <span className={`mr-2 text-sm ${hardwareVendor === 'DELL' ? 'text-white' : 'text-gray-800'}`}>
//                 Consultation Mode
//               </span>
//               <button
//                 onClick={() => hardwareVendor !== 'DELL' && setConsultationMode(!consultationMode)}
//                 className={`relative inline-flex h-6 w-11 items-center rounded-full ${
//                   hardwareVendor === 'DELL' ? 'bg-green-600 cursor-not-allowed' : 'bg-gray-700 cursor-pointer'
//                 } transition-colors focus:outline-none`}
//                 disabled={hardwareVendor === 'DELL'}
//                 title={
//                   hardwareVendor === 'DELL'
//                     ? 'Consultation Mode is enforced when Dell hardware is selected'
//                     : ''
//                 }
//               >
//                 <span
//                   className={`${
//                     consultationMode || hardwareVendor === 'DELL' ? 'translate-x-6' : 'translate-x-1'
//                   } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
//                 />
//               </button>
//               <span className={`ml-2 text-sm ${hardwareVendor === 'DELL' ? 'text-white' : 'text-gray-800'}`}>
//                 Enabled
//               </span>
//             </div>
//           </div>
//         </div>
//       </CardHeader>

//       <CardContent className="grid bg-black grid-cols-3 gap-6 p-6 text-white">
//         {/* Column 1: Essential Configuration (always required) */}
//         <div className="config-column-divider">
//           <h3 className="section-header-underlined">Essential Configuration</h3>

//           {/* Delivery Quarter */}
//           <div>
//             <label className="control-label">Select Delivery Quarter</label>
//             <Select
//               value={config.quarter}
//               onValueChange={(value) => updateConfig({ quarter: value })}
//             >
//               <SelectTrigger className="select-trigger">
//                 <SelectValue placeholder="Select Quarter" />
//               </SelectTrigger>
//               <SelectContent className="select-content">
//                 {hasSpecialAccess ? (
//                   getAvailableQuarters().map((quarter) => (
//                     <SelectItem key={quarter} value={quarter}>
//                       {quarter.replace('-', ' ')}
//                     </SelectItem>
//                   ))
//                 ) : (
//                   <SelectItem value={getCurrentQuarter()}>
//                     {getCurrentQuarter().replace('-', ' ')}
//                   </SelectItem>
//                 )}
//               </SelectContent>
//             </Select>
//           </div>

//           <div className="grid grid-cols-2 gap-2">
//             {/* Subscription Duration */}
//             <div>
//               <label className="control-label">Select Subscription Duration</label>
//               <Select
//                 value={(config.subscriptionMonths || 0).toString()}
//                 onValueChange={(value) =>
//                   updateConfig({ subscriptionMonths: parseInt(value, 10) })
//                 }
//               >
//                 <SelectTrigger className="select-trigger">
//                   <SelectValue placeholder="Select Subscription Months" />
//                 </SelectTrigger>
//                 <SelectContent className="select-content">
//                   {[36, 48, 60, 72, 84].map((months) => (
//                     <SelectItem key={months} value={months.toString()}>
//                       {months} months
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>
//             </div>

//             {/* Service Option */}
//             <div>
//               <label className="control-label">Select Service Option (No return, etc)</label>
//               <Select
//                 value={config.serviceOption}
//                 onValueChange={(value) => updateConfig({ serviceOption: value })}
//               >
//                 <SelectTrigger className="select-trigger">
//                   <SelectValue />
//                 </SelectTrigger>
//                 <SelectContent className="select-content">
//                   <SelectItem value="standard">Next Business Day</SelectItem>
//                   <SelectItem value="noReturnMedia">No Return Media</SelectItem>
//                   <SelectItem value="noReturnHardware">No Return Hardware</SelectItem>
//                 </SelectContent>
//               </Select>
//             </div>
//           </div>
//         </div>

//         {/* Column 2: Network Configuration */}
//         <div className="config-column">
//           <h3 className="section-header-underlined">Network Configuration</h3>
//           <div>
//             <label className="control-label">Select Network Interface</label>
//             <Select
//               value={config.interfaceOption}
//               onValueChange={(value) => updateConfig({ interfaceOption: value })}
//             >
//               <SelectTrigger className="select-trigger">
//                 <SelectValue placeholder="Ethernet" />
//               </SelectTrigger>
//               <SelectContent className="select-content">
//                 <SelectItem value="Ethernet">Ethernet</SelectItem>
//                 <SelectItem value="Infiniband">Infiniband</SelectItem>
//               </SelectContent>
//             </Select>
//           </div>
//         </div>

//         {/* Column 3: Director Node Configuration */}
//         <div className="config-column">
//           <h3 className="section-header-underlined">Director Nodes (D-Nodes)</h3>
//           {hasSpecialAccess ? (
//             <>
//               {/* For special access users: Director Count and Director SSD */}
//               <div>
//                 <label className="control-label">Director Count</label>
//                 <Select
//                   value={config.veloCount.toString()}
//                   onValueChange={(value) => updateConfig({ veloCount: parseInt(value) })}
//                 >
//                   <SelectTrigger className="select-trigger">
//                     <SelectValue placeholder="Select" />
//                   </SelectTrigger>
//                   <SelectContent className="select-content">
//                     {[3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
//                       <SelectItem key={n} value={n.toString()}>
//                         {n}
//                       </SelectItem>
//                     ))}
//                   </SelectContent>
//                 </Select>
//               </div>
//               <div>
//                 <label className="control-label">Director NVMe SSD</label>
//                 <Select
//                   value={config.veloSsdCapacity.toString()}
//                   onValueChange={(value) =>
//                     updateConfig({ veloSsdCapacity: parseFloat(value) })
//                   }
//                 >
//                   <SelectTrigger className="select-trigger">
//                     <SelectValue placeholder="Select" />
//                   </SelectTrigger>
//                   <SelectContent className="select-content">
//                     {veloSsdCapacities.map((size) => (
//                       <SelectItem key={size} value={size.toString()}>
//                         {size}TB
//                       </SelectItem>
//                     ))}
//                   </SelectContent>
//                 </Select>
//               </div>
//             </>
//           ) : (
//             <>
//               {/* For regular users: Single Director Count selection */}
//               <div>
//                 <label className="control-label">Select Director Count</label>
//                 <Select
//                   value={config.veloCount.toString()}
//                   onValueChange={(value) => updateConfig({ veloCount: parseInt(value) })}
//                 >
//                   <SelectTrigger className="select-trigger">
//                     <SelectValue placeholder="Select VeLO Count" />
//                   </SelectTrigger>
//                   <SelectContent className="select-content">
//                     {[3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
//                       <SelectItem key={n} value={n.toString()}>
//                         {n}
//                       </SelectItem>
//                     ))}
//                   </SelectContent>
//                 </Select>
//               </div>
//             </>
//           )}
//         </div>
//       </CardContent>
//     </Card>
//   );
};

export default BaseSystemView;
